import LoanStatusList from './LoanStatusList';

export default LoanStatusList;
